import { instances } from '../default-setup';

export const getLeaks = (params) => instances.get('security/leaks/', params);

export const getLeaksTable = (params) =>
    instances.get('security/leaks_table/', params);

export const setLeakStatus = (data) =>
    instances.put('security/leaks_table/', data);
